import { FC } from 'react';
import { SelectedRoadmap } from './SettingsTabRoadmaps';

interface StandardGrade {
  id: string;
  name: string | null | undefined;
  targetGroup: {
    id: string;
    name: string | null | undefined;
  }[];
}

interface Props {
  standardGradeNode: StandardGrade;
  selectedRoadmaps: SelectedRoadmap;
}

const PanelMenuHeaderTemplate: FC<Props> = ({ standardGradeNode, selectedRoadmaps }) => {
  const included = standardGradeNode.targetGroup.filter(avail =>
    selectedRoadmaps.targetGroup.some(sel => sel.id === avail.id),
  );
  return (
    <div className="nc_panel-menu-roadmap-header">
      <span className="font-bold" style={{ fontFamily: 'Poppins' }}>
        {standardGradeNode.name}
      </span>

      {included.length ? (
        <label className="nc_panel-menu-roadmap-header-info">{included.map(el => el.name).join(', ')}</label>
      ) : (
        <label className="nc_panel-menu-roadmap-header-info" style={{ color: 'rgba(183, 28, 27, 1)' }}>
          No Roadmap selected
          <span className="pi pi-exclamation-triangle cursor-pointer ml-2" style={{ color: '#B71C1B' }}></span>
        </label>
      )}
      <i className="nc_panel-menu-roadmap-header-arrow ml-auto"></i>
    </div>
  );
};

export default PanelMenuHeaderTemplate;
